import { NavLink, useLocation } from 'react-router-dom';

import { cx } from 'utils';
import { NavIcon } from './icons';

/**
 * MobileTabBar — a fixed bottom tab bar for phones: the nav items flagged
 * `tab: true` in navConfig (the student's five), under their short `tabLabel`.
 * Everything else stays one tap away in the drawer. `tabMatch` keeps a tab lit
 * on related pages, and the bar pads itself clear of the home indicator.
 *
 * @param {Array} items  nav entries from navConfig (only `tab` ones render)
 */
export default function MobileTabBar({ items = [] }) {
  const { pathname } = useLocation();
  const tabs = items.filter((i) => i.tab && i.to && !i.external);
  const matchesExtra = (item) => (item.tabMatch || []).some((p) => pathname === p || pathname.startsWith(`${p}/`));

  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-slate-200 bg-white px-2 pt-1.5 md:hidden"
      style={{ paddingBottom: 'calc(0.375rem + env(safe-area-inset-bottom, 0px))' }}
    >
      <ul className="grid" style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}>
        {tabs.map((item) => (
          <li key={item.label}>
            <NavLink to={item.to} end className="block focus:outline-none">
              {({ isActive: exact }) => {
                const active = exact || matchesExtra(item);
                return (
                  <span
                    className={cx(
                      'focus-ring flex flex-col items-center gap-1 rounded-xl px-1 py-1.5 text-2xs font-semibold transition-colors',
                      active ? 'bg-brand-50 text-brand-700' : 'text-slate-500'
                    )}
                  >
                    <NavIcon name={item.icon} className="shrink-0" aria-hidden />
                    {item.tabLabel || item.label}
                  </span>
                );
              }}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
